<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="title"><a id="page_iii"><strong>Howard Zinn’s Southern Diary</strong></a></h1><a id="page_iii">
<p class="subtitle">Sit-ins, Civil Rights, and Black Women’s Student Activism</p>
<p class="author"><strong><span class="small">ROBERT COHEN</span></strong><br/>Foreword by <strong><span class="small">ALICE WALKER</span></strong></p>
<p class="publisher"><img alt="Image" src="images/pub.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?769fbe62